import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod/dist/zod.js";
import * as zod from "zod";
import { useSelector } from "react-redux";
import { useInternet } from "../../../../hooks/useInternet.js";
import React, { useEffect, useState } from "react";
import { Modal } from "../../../../components/modal.jsx";
import { SimpleField } from "../../../../components/fields/simpleField.jsx";
import { SubmitButton } from "../../../../components/fields/submitButton.jsx";
import { format, parseISO } from "date-fns";
import { contactLabel } from "../../../../services/labels.jsx";
import { Button } from "../../../../components/button.jsx";

export function LookupModal({ transaction, onClose, onAdd }) {
  let { formState, control, handleSubmit, watch } = useForm({
    resolver: zodResolver(zod.object({ search: zod.string().nullish() })),
  });

  let session = useSelector((state) => state.session);
  let internet = useInternet();
  let [documents, setDocuments] = useState([]);
  let [selectedDoc, setSelectedDoc] = useState(null);
  let search = (d) => {
    return internet
      .get(`/documents?sort=-date&search=${encodeURIComponent(d.search)}`)
      .then(async (res) => setDocuments(await res.json()));
  };
  useEffect(() => {
    search({ search: "" }).then().catch();
  }, []);

  return (
    <Modal onClose={onClose} fullPage={true} fullHeight={true}>
      <div className={"flex flex-col gap-3 h-full"}>
        <form onSubmit={handleSubmit(search)} className={"flex gap-3"}>
          <SimpleField control={control} name={"search"} />
          <SubmitButton formState={formState}>Search</SubmitButton>
        </form>

        <div className={"flex-grow overflow-auto w-full"}>
          <table className={"text-left table w-full"}>
            <tr>
              <th className={"px-3 py-2"}>date</th>
              <th className={"px-3 py-2"}>reference</th>
              <th className={"px-3 py-2"}>contact</th>
              <th className={"px-3 py-2"}>amount</th>
              <th className={"px-3 py-2"}>paid</th>
              <th className={"px-3 py-2"}>actions</th>
            </tr>
            {documents.map((doc, i) => (
              <tr
                className={
                  i % 2 === 0
                    ? "bg-blue-50 hover:bg-blue-200"
                    : "bg-white hover:bg-blue-100"
                }
              >
                <td className={"px-3 py-2"}>
                  {doc.date &&
                    format(parseISO(doc.date), session.account.dateFormat)}
                </td>
                <td className={"px-3 py-2"}>{doc.reference}</td>
                <td className={"px-3 py-2"}>{contactLabel(doc.contact)}</td>
                <td className={"px-3 py-2"}>
                  {doc.amount !== null && doc.amount + " " + doc.currency}
                </td>
                <td className={"px-3 py-2"}>
                  {(doc.transactions.length > 0 ||
                    transaction.documents.find((d) => d.id === doc.id)) && (
                    <>
                      <span className={"fa fa-check"} />
                    </>
                  )}
                </td>

                <td className={"px-3 py-2 flex gap-3"}>
                  <Button
                    sizing={"s"}
                    className={"px-3 flex gap-3 items-center"}
                    onClick={() => {
                      onAdd(doc);
                      onClose();
                    }}
                  >
                    select
                  </Button>
                </td>
              </tr>
            ))}
          </table>
        </div>
      </div>
    </Modal>
  );
}
